import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { langProps } from './lang';
import type { Tone } from './tones';
import { TONE_BG } from './tones';

/**
 * A section title on a small slanted plate, an optional count and an action on the right.
 *
 *   <SectionHeader title="Last games" count={12} action={<Button size="sm">All</Button>} />
 */
export interface SectionHeaderProps {
  title: string;
  count?: number;
  action?: ReactNode;
  tone?: Tone;
  as?: 'h2' | 'h3';
  id?: string;
  className?: string;
}

export function SectionHeader({
  title,
  count,
  action,
  tone = 'butter',
  as: As = 'h2',
  id,
  className,
}: SectionHeaderProps) {
  return (
    <div className={clsx('mb-3 flex min-h-11 items-center justify-between gap-3', className)}>
      <As id={id} className={clsx('tts-plate tts-display text-base', TONE_BG[tone])} {...langProps(title)}>
        <span>
          {title}
          {count !== undefined && <span className="ml-2 font-sans text-sm font-bold not-italic">{count}</span>}
        </span>
      </As>
      {action}
    </div>
  );
}
